var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notes-container"},[_c('notes-list',{attrs:{"claimId":_vm.claim.claim_id,"mode":"list"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }